import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { LanguageSwitcher, Loading, RegularCard, ButtonCta } from "cw-styleguide-react";
import Utility from "../utility";
import { route, routeTranslated } from "../routes";
import GaHelmet from '../components/GaHelmet';

class ListingsView extends Component {
  render() {
    if (!this.props.animals) {
      return <Loading />;
    }

    return (
      <Fragment>
        <GaHelmet>
          <title>{this.props.t('route_animals_title')} | {this.props.t('route_app_title')}</title>
        </GaHelmet>
        <LanguageSwitcher to={routeTranslated('animals')} />
        <div className="gel-content-container">
          <h1>{this.props.t('animals.title')}</h1>
          <div className="gel-content-row">
            {this.props.animals.map((animal, index) => {
              return (
                <RegularCard
                  key={index}
                  width={25}
                  title={animal.name}
                  source={animal.image.url}
                  alt={animal.image.alt}
                  link={{
                    to: route('animal', { id: animal.slug, tab: this.props.t('results.tabs.personality.slug') })
                  }}
                >
                  <div dangerouslySetInnerHTML={{ __html: animal.summary }} />
                </RegularCard>
              );
            }, this)}
          </div>
          <hr />
          <ButtonCta
            url={route('step1')}
            onClick={this.props.resetAnswers}
          >
            {this.props.t('results.retake')}
          </ButtonCta>
        </div>
      </Fragment>
    );
  }
}

export default withTranslation('local')(ListingsView);
